

import { useEffect } from "react";
import { useTranslations } from "next-intl";
import { useNavigate } from "react-router-dom";
import { VideoPlayerRiv } from "@/components/VideoPlayer/VideoPlayerRiv";
import { PrimaryButton } from "@/components/Buttons/PrimaryButton";

/**
 * Catch-all 404 page. Shown by the `*` route when no other route matches.
 * Renders the NotFound Rive animation + localized "page not available" copy.
 */
export const SNotFound = () => {
  const t = useTranslations("notFound");
  const navigate = useNavigate();

  useEffect(() => {
    window.dispatchEvent(new Event("navigationEnd"));
  }, []);

  return (
    <div
      data-testid="s-not-found"
      className="flex flex-col items-center justify-center h-full w-full grow py-16 gap-4"
    >
      <VideoPlayerRiv videoName="NotFound" width="w-30 sm:w-35 lg:w-40" height="h-40 sm:h-50 lg:h-60" />
      <div className="flex flex-col items-center gap-2 max-w-sm">
        <h2 className="body-1-bold font-primary text-center">{t("title")}</h2>
        <p className="body-2-regular font-tertiary text-center">{t("description")}</p>
      </div>
      <PrimaryButton
        text={t("goHome")}
        size="small"
        width="w-max"
        onClick={() => navigate("/")}
      />
    </div>
  );
};
